"use client";

import { twMerge } from "tailwind-merge";

type TextAreaProps = {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  name?: string;
  rows?: number;
  classNames?: string;
  limit?: number;
  isDisabled?: boolean;
};

/**
 * TextArea component that allows the user to input a text
 * @param value
 * @param onChange
 * @param placeholder
 * @param name
 * @param rows
 * @param classNames
 * @returns TextArea component
 */

const TextArea = ({ value, onChange, placeholder, name, rows = 4, classNames, limit, isDisabled }: TextAreaProps) => {
  return (
    <>
      <textarea
        name={name}
        id={name}
        rows={rows}
        maxLength={limit}
        placeholder={placeholder}
        className={twMerge(
          "w-full max-w-5xl rounded-lg border border-gray-300 bg-gray-50 py-1.5 pl-3 text-primary  placeholder:text-gray-400 placeholder:text-xs sm:text-sm sm:leading-6 outline-none ring-1 ring-inset ring-gray-200 hover:bg-gray-100",
          isDisabled && "opacity-50 hover:bg-gray-50 cursor-not-allowed",
          classNames
        )}
        value={value}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => onChange(e.target.value)}
        disabled={isDisabled}
      />
    </>
  );
};

export default TextArea;
